export const setHeaderTitle = (headerTitle) => {
    if (document.querySelector('#st-header .head-tit')) {
        document.querySelector('#st-header .head-tit span').innerText = headerTitle;
    }

    document.title = headerTitle;
};

/**
 * 영업포멧변경
 * @param startTime 시작시간(0000)
 * @param endTime   종료시간(2359)
 * @returns ":"를 포함한 시작시간 ~ 종료시간
 */
export const formatTimeRange = (openTime, closeTime) => {
    const format = (time) => {
        if (!time || time.length !== 4) {
            return '--:--';
        }
        return `${time.slice(0, 2)}:${time.slice(2)}`;
    };

    return `${format(openTime)} ~ ${format(closeTime)}`;
};

/**
 * 전화포멧변경
 * @param {string} 전화번호
 * @returns "-"를 포함한 전화번호
 */
export const formatPhoneNumber = (input) => {
    if (!input) {
        return '';
    }

    const cleanInput = input.replaceAll(/[^0-9]/g, '');
    let result = '';
    const length = cleanInput.length;
    if (length === 8) {
        result = cleanInput.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else if (cleanInput.startsWith('02') && (length === 9 || length === 10)) {
        result = cleanInput.replace(/(\d{2})(\d{3,4})(\d{4})/, '$1-$2-$3');
    } else if (!cleanInput.startsWith('02') && (length === 10 || length === 11)) {
        result = cleanInput.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
    } else if (!cleanInput.startsWith('010') && (length === 10 || length === 11)) {
        result = cleanInput.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
    } else if (length === 10 || length === 11 || length === 12) {
        result = cleanInput.replace(/(\d{3,4})(\d{3,4})(\d{4})/, '$1-$2-$3');
    } else {
        result = undefined;
    }
    return result;
};
